import { AsyncStorage } from 'react-native';

export const localStorage = async (arg, key, value) => {
    try {
        switch (arg) {
            case 1:
                 await AsyncStorage.setItem(key, JSON.stringify(value));
                 return 200;
 
             case 2:
                 let res = await AsyncStorage.getItem(key)
                 if(res !== null) return JSON.parse(res);
                 return undefined;
                 
             case 3:
                 await AsyncStorage.removeItem(key)
                 return 200;

            case 4:
                await AsyncStorage.clear()
                return 200;
        
            default:
                 return 403
        }
    } catch (error) {
        console.warn(error)
        return undefined
    }
 }